import { groups } from 'services/analytics/events/groups';
import { GroupsMetadataProps } from 'services/analytics/events/propertyTypes';

export const trackingGroupPinnedFeed = (
  totalNodes: any,
  memberCount: any,
  groupName: any,
  groupType: any
) => {
  const metadata: GroupsMetadataProps = {
    '[Group] Document count': totalNodes || 0,
    '[Group] Member count': memberCount || 0,
    '[Group] Name': groupName || '',
    '[Group] Type': groupType || '',
  };
  return groups.page.viewPinned(metadata);
};
